import UserManage from './UserManage.vue'

UserManage.install = function (Vue) {
    Vue.component(UserManage.name, UserManage)
}

import UserEdit from './UserEdit.vue'

UserEdit.install = function (Vue) {
    Vue.component(UserEdit.name, UserEdit)
}

import UserDetail from './UserDetail.vue'

UserDetail.install = function (Vue) {
    Vue.component(UserDetail.name, UserDetail)
}

import UserRole from './UserRole.vue'

UserRole.install = function (Vue) {
    Vue.component(UserRole.name, UserRole)
}
export {UserManage, UserEdit, UserDetail, UserRole}
